import styled, { css } from "styled-components";

export const GoTopoButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px 0;
`;
